"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
function operationError(operation) {
	var valid = false;

	if (operation && operation.status === false) {
		valid = true;
	}

	return valid;
}

exports.default = operationError;